import { trapFocus, removeTrapFocus } from './shared/utils/focus';

class PasswordContainer extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.onBodyClickEvent = this.onBodyClick.bind(this);
    this.onEscapeKeyup = (event) => event.code.toUpperCase() === 'ESCAPE' && this.close();
    this.onButtonClick = this.close.bind(this);
  }

  connectedCallback() {
    this.detailsContainer.addEventListener('keyup', this.onEscapeKeyup);
    this.summaryToggle.addEventListener('click', this.onSummaryClick);
    this.querySelector('button[type="button"]').addEventListener('click', this.onButtonClick);

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.setAttribute('aria-expanded', 'false');

    if (this.querySelector('input[aria-invalid="true"]')) {
      this.open({ target: this.querySelector('details') });
    }
  }

  disconnectedCallback() {
    this.detailsContainer.removeEventListener('keyup', this.onEscapeKeyup);
    this.summaryToggle.removeEventListener('click', this.onSummaryClick);
    this.querySelector('button[type="button"]').removeEventListener('click', this.onButtonClick);
    document.body.removeEventListener('click', this.onBodyClickEvent);
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();

    if (event.target.closest('details').hasAttribute('open')) {
      this.close();
    } else {
      this.open(event);
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.close(false);
  }

  open(event) {
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
  }
}

customElements.define('password-container', PasswordContainer);
